import { useAgentName } from '../../../lib/use-agent-name';
import { useTranslation } from '../../../lib/i18n';
import { useGenericBi } from '../../../lib/use-generic-bi';
import { useOpenSideChat } from '../../../lib/use-open-side-chat';
import { EmptyIntro, HomeEmptyHero } from '../EmptyIntro';
import { ScrollArea } from '../ui';
import styles from './EmptyDashboard.module.css';

const PAGE = 'dashboard';

/**
 * The catch-up home with nothing on it yet (Figma `10941:75527`): the conveyor of
 * dashboard-preview cards over "One home for everything", the three steps, and the CTA
 * that asks the Maestro to build the home screen. Native parity — `HomeEmptyState` in
 * `android/.../features/Pages.kt` / `HomeEmptyView` on iOS, same copy keys.
 */
export function EmptyDashboard() {
  const { t } = useTranslation();
  const agent = useAgentName();
  const { logPageClickBi } = useGenericBi();
  const openSideChat = useOpenSideChat();

  return (
    <ScrollArea className={styles.root}>
      <div className={styles.track}>
        <div className={styles.intro}>
          <EmptyIntro
            illustration={
              <div className={styles.hero}>
                <HomeEmptyHero />
              </div>
            }
            title={t('home.empty.title')}
            steps={[
              t('home.empty.step1', { agentName: agent.short }),
              t('home.empty.step2'),
              t('home.empty.step3'),
            ]}
            ctaLabel={t('home.empty.cta')}
            onCta={() => {
              logPageClickBi({ page_name: PAGE, button_name: 'get_home_screen' });
              openSideChat({ kind: 'new', message: t('home.empty.ctaSeed') });
            }}
          />
        </div>
      </div>
    </ScrollArea>
  );
}
